import React from "react";

// nodejs library that concatenates strings
import classnames from "classnames";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Button,

} from "reactstrap";



function ServicesNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar 
      className={classnames("fixed-top", navbarColor)} 
      color-on-scroll="300"
      expand="lg"
      style={{
        background: navbarColor === "navbar-transparent" 
          ? 'rgba(102, 126, 234, 0.1)' 
          : 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        boxShadow: navbarColor === "navbar-transparent" 
          ? 'none' 
          : '0 8px 32px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease'
      }}
    >
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            href="/"
            style={{
              background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontSize: '1.8rem',
              fontWeight: '800',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}
          >
            <b style={{ color: "#f5593d" }}>T{" "}</b>
            <small><b> | Tri-Advise</b></small>
          </NavbarBrand>

          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
            style={{
              border: 'none',
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '8px',
              padding: '8px 12px'
            }}
          >
            <span className="navbar-toggler-bar bar1" style={{ background: 'white' }} />
            <span className="navbar-toggler-bar bar2" style={{ background: 'white' }} />
            <span className="navbar-toggler-bar bar3" style={{ background: 'white' }} />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
              <NavLink 
                href="/nfc" 
                activeClass="active" 
                spy={true} 
                smooth={true}
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: '500',
                  fontSize: '1rem',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.1)';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                }}
              >
                <i className="nc-icon nc-credit-card" style={{ marginRight: '8px' }} /> 
                NFC Card
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                to="/course" 
                tag={Link}
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: '500',
                  fontSize: '1rem',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.1)';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                }}
              >
                <i className="nc-icon nc-book-bookmark" style={{ marginRight: '8px' }} /> 
                Courses
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                to="/services" 
                tag={Link}
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: '500',
                  fontSize: '1rem',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.1)';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                }}
              >
                <i className="nc-icon nc-layout-11" style={{ marginRight: '8px' }} /> 
                Services
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.facebook.com/TriAdvise/"
                target="_blank"
                title="Like us on Facebook"
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(59, 89, 152, 0.2)';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <i className="fa fa-facebook-square" />
                <p className="d-lg-none">Facebook</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.instagram.com/tri_advise/"
                target="_blank"
                title="Follow us on Instagram"
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(225, 48, 108, 0.2)';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <i className="fa fa-instagram" />
                <p className="d-lg-none">Instagram</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.linkedin.com/company/tri-advise/"
                target="_blank"
                title="Connect on LinkedIn"
                style={{
                  color: 'rgba(255,255,255,0.9)',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(0, 119, 181, 0.2)';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.9)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <i className="fa fa-linkedin" />
                <p className="d-lg-none">LinkedIn</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <Button
                className="btn-round"
                style={{
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '25px',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
                  transition: 'all 0.3s ease',
                  marginLeft: '15px'
                }}
                href="/contact"
                target="_blank"
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 107, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 107, 0.3)';
                }}
              >
                <i className="fa fa-rocket" style={{ marginRight: '8px' }} />
                Get Connected
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default ServicesNavbar;
